<template>
  <div v-if="state.speakers && state.speakers.length > 0 && state.shown" class="my-20">
    <Carousel :cardWidth="320" :visibleCards="3">
        <template v-slot:label>
          <p class="tracking-[-0.64px] uppercase text-lg font-mono text-brand-purple leading-[86.5%] font-medium">přednášející</p>
          <p class="font-semibold tracking-[-2.56px] mt-3 max-w-[420px] leading-[86.5%] md:text-5xl lg:text-[64px] text-[32px]">Na koho se můžete těšit</p>
        </template>

        <template v-slot:default>
            <div v-for="(speaker, j) in state.speakers" :key="j" class="inline-flex md:pb-2 md:pt-[3.5rem]">
                <SpeakerCard  :speaker="speaker" />
            </div>
        </template>
    </Carousel>
  </div>
</template>

<script setup>
import Carousel from '../Carousel/Carousel.vue'
import SpeakerCard from './SpeakerCard.vue';

import { useSpaeakersStore } from '../../stores/speakers';
const state = useSpaeakersStore();
</script>
